import { FC, useMemo } from 'react';

import Contents from './Contents';
import { DescriptionConfig, DescriptionContext } from './DescriptionContext';
import Feedback from './Feedback';
import Guide from './Guide';
import Section from './Section';

type DescriptionComponent<P> = FC<React.PropsWithChildren<React.PropsWithChildren<P>>> & {
  Guide: typeof Guide;
  Feedback: typeof Feedback;
  Contents: typeof Contents;
  Section: typeof Section;
};

const Description: FC<React.PropsWithChildren<React.PropsWithChildren<DescriptionComponent<unknown>>>> = ({ children }) => {
  const descriptionConfig: DescriptionConfig = useMemo(() => ({}), []);
  return <DescriptionContext.Provider value={descriptionConfig}>{children}</DescriptionContext.Provider>;
};

export default Description as DescriptionComponent<unknown>;
